<template>
  <div class="studyplan">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header
      :title="title"
      back-type="back-app"/>

    <!-- 一封信 -->
    <studyplan-email />
    <!-- 选择计划 -->
    <studyplan-list />
    <!-- 开启友邻学习计划 -->
    <studyplan-apply @click="onClickPay" />
    
  </div>
</template>

<script>
/**
 * 专清计划：一学期开放四个学习计划，帮助无限卡学员学完课程。
 */
import { mapGetters } from 'vuex';
import Body from '@/mixins/body';
import UseShareCode from '@/mixins/body/use-sharecode';
import components from './components'
import { toast, throttle } from '@/utils'
import { setShareData } from '../options'
import { toLoginView } from '@/utils/init/env-init'

// 操作名称
const action = 'buyGoodsPlan'

export default {
  name: 'goods-studyplan',
  mixins: [Body, UseShareCode],
  components: {
    ...components
  },
  data() {
    return {
      title: '友邻学院'
    }
  },
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail',
      'termInfo',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('goods-studyplan/plan', [
      'selectedPlan',
      'termApplyResult'
    ]),
    hasSelect() {
      return this.selectedPlan.goodsId > 0
    }
  },
  watch: {
    // 查询的报名结果
    'termInfo.joinValid'(value) {
      if (value === false) {
        this.goSuccessView(this.termInfo)
      } else if (value === true) {
        this.clearTermApplyResult(this.termInfo)
      }
    }
  },
  activated() {
    // 返回页面时
    const id = this.termInfo.termId
    if (id) {
      this.$store.commit('goods-studyplan/plan/getTermApplyResult', { id })
      this.$nextTick(() => {
        this.isJoinValid()
      })
    }
  },
  methods: {
    // 设置分享地址
    setShareData,
    // 获取商品详情的特定参数
    getGoodsDetail_params() {
      return {
        busiType: 'studyplan'
      }
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      setTimeout(() => {
        this.getGoodsDetail() // 刷新商品
      })
    },
    // 商品详情查询后，检查购买行为
    enterAfterLogin(res) {
      return this.$store.dispatch('user/login/enterAfterLogin', { action })
        .then(action => {
          this.$nextTick(this.onClickPay)
          return action
        })
    },
    // 报名
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    isJoinValid({ type } = {}) {
      const { termInfo, termApplyResult } = this
      console.log('goods> studyplan.isJoinValid', termInfo, termApplyResult, 'type: ', type)
      if (termApplyResult.joinValid === false) {
        if (!termApplyResult.userTermId) {
          toast(termApplyResult.message)
        } else {
          return this.goSuccessView()
        }
      } else if (termInfo.joinValid === false) {
        return this.goSuccessView(termInfo)
      }
    },
    onClickPay: throttle(function() {
      if (!this.hasUser()) {
        return
      }
      const { termInfo } = this
      if (termInfo.profileValid === false) {
        return toast('仅限无限卡用户报名')
      }
      // 从登录入口过来的，检查已加入
      if (this.isJoinValid({ is: 'toast' })) {
        return
      }
      if (!this.hasSelect) {
        return toast('请选择一个学习计划')
      }
      if (this.selectedPlan.canBuy === false) {
        return toast('报名已结束')
      }
      // 订单页面
      if (this.termApplyResult.joinValid === false && !this.termApplyResult.userTermId) {
        return;
      }
      this.goOrderView()
    }, 2000, { leading: true }),
    goOrderView() {
      this.$router.push({
        path: `/goods-studyplan-order/${this.termInfo.termId}`
      })
    },
    clearTermApplyResult(result) {
      const { termId } = result
      result = { termId }
      this.$store.commit('goods-studyplan/plan/setTermApplyResult', result)
    },
    goSuccessView(result) {
      if (result == null) {
        result = this.termApplyResult
      } else {
        // 设置报名的计划
        this.$store.commit('goods-studyplan/plan/setTermApplyResult', result)
      }
      // 打断流程
      console.log('goods> goSuccessView', result)
      if (!result.userTermId) {
        return true
      } else {
        this.$router.replace({
          path: `/goods-studyplan-success/${result.userTermId}`
        })
      }
      return true
    }
  }
}
</script>

<style>

</style>